import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  CustomResultOfPaginatedListOfGetInformationUsersSeenListDto,
  GetInformationUsersSeenListDto,
  PaginatedListOfGetInformationUsersSeenListDto,
} from 'src/app/core/api/models';
import { InformationsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { TransferDataService } from 'src/app/core/services/transfer-data.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';

import { SharePipesModule } from 'src/app/core/pipes/pipes.module';
import { ShareDirectivesModule } from 'src/app/core/directives/directives.module';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { PageNames } from 'src/app/configs/page-names.enum';

@Component({
    selector: 'app-information-users-seen',
    imports: [
        BaseIndexModule,
        FormsModule,
        ReactiveFormsModule,
        SharePipesModule,
        ShareDirectivesModule,
    ],
    templateUrl: './information-users-seen.component.html'
})
export class InformationUsersSeenComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.informationUsersSeen;
  modelWithPagination$: Observable<PaginatedListOfGetInformationUsersSeenListDto>;
  items$: Observable<Array<GetInformationUsersSeenListDto>>;
  informationId: number;
  protected currentService = inject(InformationsService); 
  //#endregion

  constructor() {
    super();

    this.informationId = TransferDataService.id;
  }
  ngOnInit() {
    try {
      // اگر کاربر با انتخاب گزینه در پرنت آمده بود آیدی پرنت رو به یوآرال اضافه میکنیم و اگر با یوآرال آمده بود آیدی پرنت رو از یوآرال میخونیم
      this.showParent = false;
      this.setParentQueryString();
      if (this.informationId && !window.location.search.includes('key-')) {
        this.location.go(
          window.location.pathname +
            window.location.search +
            '?' +
            QueryStringTypesEnum.UsersSeen_key +
            '=' +
            this.informationId
        );
      } else {
        let params = this.routingState.parseQueryString();
        for (const [key, value] of Object.entries(params)) {
          if (key == QueryStringTypesEnum.UsersSeen_key) {
            this.informationId = +value;
          }
        }
      }

      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.showHelpBtn = false;
      this.pageConfig.tableConfig.showOperationColumn = false;
      this.pageConfig.showRefreshBtn = true;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs + 'fields.';

    this.tableColumns = [
      {
        title: this.localizer.userName,
        name: 'userName',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: this.localizer.firstName,
        name: 'userFirstName',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: this.localizer.lastName,
        name: 'userLastName',
        hasSearch: true,
        dir: 'ltr',
      },
      { title: this.localizer.userId, name: 'userId', hasSearch: true },
      {
        title: `${this.tableVocabs}seenDateTime`,
        name: 'seenDateTime',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  getPaginationApi(): Observable<CustomResultOfPaginatedListOfGetInformationUsersSeenListDto> {
    return this.currentService.informationsGetInformationUsersSeenList({
      body: {
        ...this.getBaseModelWithPaginationParams(),
        informationId: this.informationId,
      },
    });
  }

  setDefaultTableSort() {
    this.sortObject.push({ columnName: 'seenDateTime', sort: 1 });
  }
}
